import { Injectable, inject } from '@angular/core';
import { AppStore } from 'app/store/app.store';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  private readonly store = inject(AppStore);

  /** Load */
  async load(): Promise<void> {
    await this.store.initializeApp();
  }
}
